import { Koi } from '@ksyos/koi';
import { maxInt32 } from '@common/constants';

export const positiveInt32Schema = Koi.number().min(0).max(maxInt32);
